/**
 * @generated SignedSource<<9a548ebeda95d474713e688f46523e4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TeamSettingsMutation$variables = {
  id: string;
  objectivesFilterAssignee?: any | null;
  objectivesFilterCycle?: any | null;
  objectivesFilterStatus?: string | null;
};
export type TeamSettingsMutation$data = {
  readonly updateTeam: {
    readonly team: {
      readonly objectivesFilterAssignee: ReadonlyArray<string> | null;
      readonly objectivesFilterCycle: ReadonlyArray<string> | null;
      readonly objectivesFilterStatus: string | null;
    };
  } | null;
};
export type TeamSettingsMutation = {
  response: TeamSettingsMutation$data;
  variables: TeamSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectivesFilterAssignee"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectivesFilterCycle"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectivesFilterStatus"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "objectivesFilterAssignee",
    "variableName": "objectivesFilterAssignee"
  },
  {
    "kind": "Variable",
    "name": "objectivesFilterCycle",
    "variableName": "objectivesFilterCycle"
  },
  {
    "kind": "Variable",
    "name": "objectivesFilterStatus",
    "variableName": "objectivesFilterStatus"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterAssignee",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterStatus",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesFilterCycle",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UpdateTeamMutation",
        "kind": "LinkedField",
        "name": "updateTeam",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "UpdateTeamMutation",
        "kind": "LinkedField",
        "name": "updateTeam",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "10764085f1e4c5d841321589baf8ae3a",
    "id": null,
    "metadata": {},
    "name": "TeamSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation TeamSettingsMutation(\n  $id: ID!\n  $objectivesFilterAssignee: JSON\n  $objectivesFilterStatus: String\n  $objectivesFilterCycle: JSON\n) {\n  updateTeam(id: $id, objectivesFilterAssignee: $objectivesFilterAssignee, objectivesFilterStatus: $objectivesFilterStatus, objectivesFilterCycle: $objectivesFilterCycle) {\n    team {\n      objectivesFilterAssignee\n      objectivesFilterStatus\n      objectivesFilterCycle\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "85d9b00aeb9b0342eaed584ca4781276";

export default node;
